import { Typography } from '@mui/material';
import { AppUpdate } from '@capawesome/capacitor-app-update';
import { Capacitor } from '@capacitor/core';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import AppModal from 'components/shared/AppModal/AppModal';
import { APP_CONFIG } from 'api/interfaces/config';
import { modalStore } from 'stores/modalStore/modalStore';

const UpgradeRequiredModal = observer(function UpgradeRequiredModal() {
	const { t } = useTranslation();

	const openStore = async () => {
		try {
			if (Capacitor.getPlatform() === 'ios') await AppUpdate.openAppStore({ appId: APP_CONFIG.appId });
			else await AppUpdate.openAppStore();
		} catch (error) {
			console.error(error);
		}
	};

	return (
		<AppModal
			show={modalStore.showUpgradeRequiredModal}
			onClick={() => openStore()}
			content={{
				element: <Typography>{t('modals.upgradeRequiredModal.content')}</Typography>,
			}}
			header={{
				text: t('modals.upgradeRequiredModal.header'),
			}}
			mainButton={{
				text: t('modals.upgradeRequiredModal.button'),
			}}
		/>
	);
});

export default UpgradeRequiredModal;
